import { path } from "@/utils/url";

/**
 * ログインページ共通レイアウト（ロゴ + センタリング外枠）
 *
 * PRODUCT_DEV-570: 各プロダクトから `?productId=xxx` 付きで遷移してくるため、
 * productId=unizo の場合のみ Unizo ロゴを表示する（それ以外は umeee 共通ロゴ）。
 * 呼び出し側 (LoginForm / MFA / パスワード系など多数) を変更せずに済むよう、
 * ここで URL クエリの productId を直接参照する。
 *
 * PRODUCT_DEV-750: Minizo（メモ・ToDo だけのデモ版・PRODUCT_DEV-688）を追加。
 * Minizo は Unizo と同じ Cognito・同じ Portal でログインする（アップグレード時に
 * アカウントを作り直させないため）ので、ここで出し分ける必要がある。
 * ロゴは正式版が無いため暫定の SVG ワードマーク。
 */
const resolveBrandLogo = (): { src: string; alt: string } => {
  const productId =
    typeof window !== "undefined"
      ? new URLSearchParams(window.location.search).get("productId")
      : null;
  if (productId === "unizo") {
    return { src: path("/img/icon/unizo_logo_full.png"), alt: "Unizo" };
  }
  if (productId === "minizo") {
    return { src: path("/img/icon/minizo_logo_full.svg"), alt: "Minizo" };
  }
  return { src: path("/img/icon/umeee_logo_full.webp"), alt: "Umeee" };
};

export const AuthPageLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const logo = resolveBrandLogo();
  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-12">
          <img src={logo.src} alt={logo.alt} className="mx-auto h-12 w-auto" />
        </div>
        {children}
      </div>
    </div>
  );
};
